export const environment = {
  production: true,
  //baseUrl: 'http://frontendr.io:8080/',
  //chatUrl: 'http://frontendr.io:8080/websocket/tracker',
    baseUrl: 'https://app.thinkingcode.com/',
    chatUrl: 'https://app.thinkingcode.com/websocket/tracker',
  firebase: {
      apiKey: "AIzaSyDZ6utOx2F9GRr34TQi5A2yxdPEOxoFDC0",
      authDomain: "sentinel-e78ad.firebaseapp.com",
      databaseURL: "https://sentinel-e78ad.firebaseio.com",
      projectId: "sentinel-e78ad",
      storageBucket: "sentinel-e78ad.appspot.com",
      messagingSenderId: "821530460104",
      appId: "1:821530460104:web:efaff25978d59249"
  }
};
